import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';
import { billingClient } from '@/lib/api/ts-rest';

export function useBillingRun(runId: string | null) {
  return useQuery({
    queryKey: queryKeys.billing.run(runId),
    queryFn: async () => {
      const res = await billingClient.getRun({ params: { id: runId! } });
      if (res.status !== 200) throw new Error('Failed to load run');
      return res.body;
    },
    enabled: !!runId,
    // Poll while the publication is running, stop once done.
    refetchInterval: (query) =>
      query.state.data?.status === 'publishing' ? 1000 : false,
  });
}
